import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOASecurities() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ securities, setSecurities ] = useState(powerOfAttorney.securities_transactions || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../banking');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      securities_transactions: securities
    }));
    navigate('../insurance-annuity');
  }, [ securities, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-securities screen-container screen">
      <ScreenHeader
        title="Securities Transactions"
        description="Decide whether to grant your agent power over your investments"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Securities Powers?</h3>
        <p>
          Securities powers allow your agent to manage your investment accounts, including:
        </p>
        <ul className="securities-list">
          <li>Stocks and bonds</li>
          <li>Mutual funds and ETFs</li>
          <li>Retirement accounts (401k, IRA, etc.)</li>
          <li>Brokerage accounts</li>
          <li>Investment trusts</li>
          <li>Commodities and futures</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Buy and sell securities</li>
          <li>Transfer funds between accounts</li>
          <li>Reinvest dividends and interest</li>
          <li>Change investment allocations</li>
          <li>Access account statements and records</li>
          <li>Make contributions to retirement accounts</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="securities-yes"
            label="Yes"
            description="Grant power over securities transactions"
            value="yes"
          />
          <AssetDistributionOption
            id="securities-no"
            label="No"
            description="Do not grant power over securities transactions"
            value="no"
          />
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
